export default __webpack_public_path__ + "static/10_33-6ee314d3e69cde491386ba25ecde717b.png";